/**
 * Calendar provider support link constants
 * These constants define the support URLs for different provider types and regions
 */

// Managed Calendar Names
// These must match the backend constants in CalendarService/app/lib/lyra/constants/provider_defaults.py
export const BEND_MANAGED_CALENDAR_NAME = 'Availability'

// Calendar Landing Page Support Links
export const CALENDAR_LANDING_PAGE_SUPPORT_LINK_DA =
  'https://provider-support.lyrahealth.com/hc/en-us/articles/38528605874963--HOLD-New-CC-self-service-guide'
export const CALENDAR_LANDING_PAGE_SUPPORT_LINK_OUS =
  'https://icas-provider-support.zendesk.com/hc/en-us/articles/40542045793939/'

// Calendar Setup Learn More Links
export const CALENDAR_SETUP_LEARN_MORE_LINK_DA =
  'https://provider-support.lyrahealth.com/hc/en-us/articles/38528605874963--HOLD-New-CC-self-service-guide'
export const CALENDAR_SETUP_LEARN_MORE_LINK_OUS =
  'https://icas-provider-support.zendesk.com/hc/en-us/articles/40542045793939/'

// Calendar Support Ticket Links
export const CALENDAR_SUPPORT_TICKET_LINK_DA =
  'https://provider-support.lyrahealth.com/hc/en-us/requests/new?ticket_form_id=26162178922387'
export const CALENDAR_SUPPORT_TICKET_LINK_OUS = 'https://icas-provider-support.zendesk.com/hc/en-us/requests/new'

// Calendar Selection Page Links
export const CALENDAR_SELECT_SUBMIT_TICKET_LINK_DA =
  'https://provider-support.lyrahealth.com/hc/en-us/requests/new?ticket_form_id=26162178922387'
export const CALENDAR_SELECT_SUBMIT_TICKET_LINK_OUS = 'https://icas-provider-support.zendesk.com/hc/en-us/requests/new'

export const CALENDAR_SELECT_LEARN_MORE_LINK_DA =
  'https://provider-support.lyrahealth.com/hc/en-us/articles/38528605874963-Lyra-Calendar-Setup-and-FAQ-Guide'
export const CALENDAR_SELECT_LEARN_MORE_LINK_OUS =
  'https://icas-provider-support.zendesk.com/hc/en-us/articles/40542045793939/'

export const CALENDAR_SELECT_SUBMIT_REQUEST_LINK_DA =
  'https://provider-support.lyrahealth.com/hc/en-us/requests/new?ticket_form_id=26162178922387'
export const CALENDAR_SELECT_SUBMIT_REQUEST_LINK_OUS = 'https://icas-provider-support.zendesk.com/hc/en-us/requests/new'

// Calendar Header Help Links
export const CALENDAR_HEADER_HELP_LINK_DA =
  'https://provider-support.lyrahealth.com/hc/en-us/articles/38528605874963--HOLD-New-CC-self-service-guide'
export const CALENDAR_HEADER_HELP_LINK_OUS =
  'https://icas-provider-support.zendesk.com/hc/en-us/articles/40542045793939/'

// Calendar Hybrid Authorization Modal Links
export const CALENDAR_HYBRID_AUTH_HELP_LINK_DA =
  'https://provider-support.lyrahealth.com/hc/en-us/articles/35833741844115-Understanding-the-Google-Calendar-Integration-with-Lyra'
export const CALENDAR_HYBRID_AUTH_TICKET_LINK_OUS = 'https://icas-provider-support.zendesk.com/hc/en-us/requests/new'
